export const consentPreferencesToken = 'consent_preferences_token';
